<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2024-09-25 10:51:54
-->
<template>
  <el-dialog
    title="请选择组织"
    ref="root"
    width="600px"
    :visible.sync="visible"
    append-to-body
  >
    <el-table
      ref="tenantTab"
      :data="tenants"
      style="width: 100%"
      class="border-box"
      size="small"
      height="200"
      stripe
      highlight-current-row
      :show-header="false"
      @current-change="handleSelectionChange"
    >
      <el-table-column prop="name" label="名称"></el-table-column>
    </el-table>
    <div slot="footer" class="flex-row-reverse">
      <el-button type="primary" size="small" @click="handleSelected"
        >确定</el-button
      >
      <el-button
        size="small"
        style="margin-right: 12px"
        @click="visible = false"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { writeLocal } from "../utils/localStorageUtils";
export default {
  data() {
    return {
      tenants: [],
      visible: false,
      selectedTenant: null,
    };
  },
  computed: {
    ...mapGetters(["getUserInfo", "getTenantId"]),
  },
  methods: {
    showDialog(tenants, selectedTenantId) {
      console.log("@@-@@ showDialog", tenants, selectedTenantId);
      this.tenants = tenants;
      if (!!selectedTenantId) {
        this.selectedTenant = tenants.find(
          (tenant) => tenant.id === selectedTenantId
        );
      } else {
        this.selectedTenant = null;
      }
      this.$nextTick(() => {
        this.$refs.tenantTab.setCurrentRow(this.selectedTenant);
      });
      this.visible = true;
    },
    select(tenants, selectedTenantId) {
      return new Promise((resolve, reject) => {
        let selectedTenant = null;
        this.$once("selected", (tenant) => {
          selectedTenant = tenant;
        });
        this.$refs.root.$once("closed", () => {
          setTimeout(() => {
            resolve(selectedTenant);
          }, 0);
        });
        this.showDialog(tenants, selectedTenantId);
      });
    },
    handleSelectionChange(newRow, oldRow) {
      this.selectedTenant = newRow;
    },
    handleSelected() {
      if (!this.selectedTenant) {
        this.$$flash("请先选择组织", "warning");
        return;
      }

      this.visible = false;
      if (!!this.getUserInfo && !!this.getUserInfo.phone) {
        console.log(
          "#-# handleSelected[inner]",
          this.getUserInfo,
          this.getUserInfo.phone,
          this.selectedTenant.id
        );
        writeLocal(this.getUserInfo.phone, this.selectedTenant.id);
      }
      this.$emit("selected", this.selectedTenant);
    },
  },
  mounted() {
    console.log("#-# getUserInfo", this.getUserInfo);
  },
};
</script>

<style>
</style>